/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopModel = IModel<
  IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopRequest,
  TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse
>;

export interface IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopRequest {
  section: ESection;
}

export type TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse =
  | IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse200
  | IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse400;

export interface IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse200
  extends IModelResponse<IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse> {
  statusCode: 200;
}

export interface IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse400
  extends IModelResponse<IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponseError> {
  statusCode: 400;
}

export interface IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse {}

export interface IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponseError {
  errors: any[];
  message: string;
}

export type TResponses =
  | IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse
  | IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponseError;

export enum ESection {
  /** Раздел "Сообщения" **/
  Main = 'main',
  /** Раздел "Непрочитанные" **/
  Unread = 'unread',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse): TResponse200;
  400(response: IChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponseError): TResponse400;
}
